import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { MeetingType, MeetingLocation, MeetingRoom } from '../../models/MasterMOM';
import { UtilityService } from '../../services/utility.service';
import { UserService } from '../../services/user.service';
import { MasterMOMService } from '../../services/master-mom.service';
import { ToastrUtilsService } from './../../services/toastr-utils.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Notiflix from "notiflix";
@Component({
  selector: 'app-meeting-room',
  templateUrl: './meeting-room.component.html',
  providers: [ToastrUtilsService]
})
export class MeetingRoomComponent implements OnInit {
  @ViewChild('meetingRoomAdd', { static: false }) meetingRoomAdd: TemplateRef<any>;
  public data: any=[];
  public user_data: any;
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
 
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  model: any = {};
  public permission: number = 1;
  user: any = {};
  login_UserID: number; // number
    modalRef: any;
  public meetingTypeForm: FormGroup;
    dataList: any=[];
    searchText: any;
    locationUno_data: any=[];
    noDataImage: string;
  isLoader: boolean = false;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private modalService: BsModalService,
    private userService: UserService,
    private _router: Router,
   ) { }

  ngOnInit() {
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.login_UserID = user.id;
      var Role = Number(user.role);
      if (Role != 1) {
        this._router.navigate(['/dashboard'])
      }
    }
        
    this.loadMeetinglocation();
    this.loadMeetingRoom();
    //this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    //if (this.permission == 1) {
    //  this.toolbar = ['Add', 'Edit', 'Delete', 'Search', 'ExcelExport'];
    //}
    //else
    //  this.toolbar = ['Search', 'ExcelExport'];

    //this.pageSettings = { pageSize: 20, pageSizes: true };
    //this.filterSettings = { type: 'Excel' };




  }


  loadMeetinglocation() {

    //this.spinner.show();
    let inpValue = new MeetingLocation();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;

    this.momMasterservice.getLocation(inpValue)
      .subscribe(data => {

        this.locationUno_data = data;
        //console.log(this.postData);
       //this.spinner.hide();
      },
        () => {
         // //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       // this.spinner.hide();
      });
  }


  // Get MeetingRoom list
  loadMeetingRoom() {
   // Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader=true;
    let inpValue = new MeetingRoom();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;

    this.momMasterservice.getMeetingRoom(inpValue)
      .subscribe(data => {
        this.isLoader = false;
        this.data = data;
        this.dataList = data;
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        (error) => {
          //Called when error
          this.isLoader = false;
          //Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.isLoader = false;
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      });
  }

  exportExcel() {


    let items: any = [];
    const wb: any = { SheetNames: [], Sheets: {} };
    let filename = 'master.xlsx';



    for (var i = 0; i < this.data.length; i++) {
      items.push({
        ID: i + 1,
        Meeting_Room_Code: this.data[i].meetingRoomCode,
        Meeting_Room_Name: this.data[i].meetingRoomName,
        Location_Name: this.data[i].locationName
      });
    }
    filename = 'MeetingRoom.xlsx'
    var ws = XLSX.utils.json_to_sheet(items);
    wb.SheetNames.push("meetingroom"); wb.Sheets["meetingroom"] = ws;


    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataVal: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    if (window.navigator.msSaveBlob) //IE & Edge
    {
      //msSaveBlob only available for IE & Edge
      window.navigator.msSaveBlob(dataVal, filename);
    }
    else //Chrome & FF
    {
      var url = window.URL.createObjectURL(dataVal);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }
  }

  openModal(template2: TemplateRef<any>, add: any) {
    ;
    this.pageAction = add;
    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable' }, this.ngbModalOptions)
    );
    if (this.pageAction == "add") {
      this.model.meetingRoomCode = '';
      this.model.meetingRoomName = '';
      this.model.locationUno = '';
    }
    //this.modalPub.hide();
  }
  
 
  
  AddEditMeetingRoom() {

    ;
    if (this.DuplicateNameCheck(this.utilityService.isStringNull(this.model.meetingRoomCode), this.utilityService.isNumericNull(this.model.meetingRoomUno))) {

      this.toastr.ErrorCustomMessage('Duplicates not allowed');
      return false;
    }
    if (this.model.meetingRoomCode.trim() == '' && this.model.meetingRoomName.trim() == '') {
      this.toastr.ErrorCustomMessage('Please enter required values');
      return false;
    }
    let obj = new MeetingRoom();
    obj.meetingRoomUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.model.meetingRoomUno);
    obj.meetingRoomCode = this.utilityService.isStringNull(this.model.meetingRoomCode);
    obj.meetingRoomName = this.utilityService.isStringNull(this.model.meetingRoomName);
    obj.locationUno = this.utilityService.isNumericNull(this.model.locationUno);
      obj.userUno = this.login_UserID;

      
    this.momMasterservice.addEditMeetingRoom(obj)
        .subscribe(() => {
          this.toastr.SaveMessage;
          this.loadMeetingRoom();
          this.modalRef.hide();

          //this.spinner.hide();
        },
          () => {
            //Called when error
            this.toastr.ErrorMessage;
           // this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    
  }

  editMeetingRoom(data: any) {
    ;
    this.pageAction = "edit";
    this.model.meetingRoomUno = this.utilityService.isNumericNull(data.meetingRoomUno)
    this.model.meetingRoomCode = this.utilityService.isStringNull(data.meetingRoomCode);
    this.model.meetingRoomName = this.utilityService.isStringNull(data.meetingRoomName);
    this.model.locationUno = this.utilityService.isNumericNull(data.locationUno);
  }

  DuplicateNameCheck(meetingRoomCode: string, meetingRoomUno: number) {
    var rtnValue = false;
    if (this.data != null && this.data != undefined) {
     
      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.meetingRoomCode.toLocaleLowerCase() == meetingRoomCode.toLocaleLowerCase() && meetingRoomUno != grdData.meetingRoomUno) {
          rtnValue = true;
        }
      });

      
    }
    return rtnValue;
  }


  DeleteConfirm(data: any) {
    let temp = this;
    Notiflix.Confirm.Show('Delete Confirm', 'Are you sure you want to delete this record?', 'Yes', 'No', function () {

      Notiflix.Loading.Standard('Loading...');
      temp.DeleteMeetingRoom(data);

    }, function () { // No button callback
      return false;
    });

  }
  DeleteMeetingRoom(data1: any) {

    let obj = new MeetingRoom();
    obj.meetingRoomUno = data1.meetingRoomUno;
    obj.userUno = this.login_UserID;
    //objDeaprtment.tenantUno = 1;
    
    this.momMasterservice.deleteMeetingRoom(obj)
      .subscribe(() => {
        
        this.toastr.DeleteMessage();
        this.loadMeetingRoom();
        setTimeout(() => {

          Notiflix.Loading.Remove();
        }, 400);
       // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
          //Called when error
         // this.spinner.hide();
          Notiflix.Loading.Remove();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
        Notiflix.Loading.Remove();
      });

  }

  searchGrid() {
    ;
    if (this.searchText != "") {
      this.data = this.dataList.filter(a =>
        a.locationName && a.locationName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.meetingRoomName && a.meetingRoomName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.meetingRoomCode && a.meetingRoomCode.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.data = this.dataList;
  }
}
